import { createRouter, createWebHistory } from 'vue-router'
import home from '@/router/router-item/home.js'
import homeApp from '@/router/router-item/homeApp.js'
import sugSolicitation from '@/router/router-item/sugSolicitation.js' // 人民建议征集
const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  // 首页
  {
    path: '/index',
    name: '首页',
    component: () => import('@/views/index/index.vue'),
    children: home.routerList,
    meta: {
      viewport: 'width=1250, user-scalable=no'
    }
  },
  // 首页App
  {
    path: '/indexApp',
    name: '首页（手机端）',
    component: () => import('@/views/indexApp/index.vue'),
    children: homeApp.routerList,
    meta: {
      viewport: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
    }
  },
  // 人民建议征集
  {
    path: '/sugSolicitation',
    name: '人民建议征集',
    component: () => import('@/views/sugSolicitation/index.vue'),
    children: sugSolicitation.routerList,
    meta: {
      viewport: 'width=1300, user-scalable=no'
    }
  },
  // 预览
  {
    path: '/previewImage',
    component: () => import('@/views/previewImage.vue'),
    name: '预览',
    children: [],
    meta: {
      viewport: 'width=1300, user-scalable=no'
    }
  },
  // 页面不存在
  {
    path: '/:catchAll(.*)',
    name: 'notFound',
    component: () => import('@/views/notFound.vue'),
    meta: {
      viewport: 'width=1300, user-scalable=no'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.viewport) {
    document.querySelector('meta[name="viewport"]').setAttribute('content', to.meta.viewport);
  }
  next();
});
export default router
